import React from "react";

// Components
import { FieldArray } from "formik";

// Utils
import FloatingActionButton from "../../../../ui/widgets/floating-action-button";
import SectionItemContainer from "../../../../ui/layout/page/forms-container/section-item-container";

interface MultiFormInterface<T> {
  name: string;
  formData: T[];
  removeButtonText: string;
  addButtonText: string;
  alert?: string;
  limit: number;
  createDefaultItemData: () => T;
  renderFormComponent: (
    data: T,
    name: string,
    index: number,
  ) => React.ReactNode;
  onAddItem?: () => void;
}

export default function MultiForm<T>(
  props: MultiFormInterface<T>,
): React.JSX.Element {
  const {
    name,
    formData,
    removeButtonText,
    addButtonText,
    alert,
    renderFormComponent,
    limit,
    createDefaultItemData,
    onAddItem,
  } = props;

  return (
    <FieldArray name={name}>
      {({ push, pop }) => (
        <>
          {formData &&
            formData.length > 0 &&
            formData.map((data, index) => {
              return (
                <React.Fragment key={`${index}`}>
                  {index !== 0 && (
                    <SectionItemContainer>
                      <FloatingActionButton
                        kind="remove"
                        text={removeButtonText}
                        onClick={() => pop()}
                      />
                    </SectionItemContainer>
                  )}
                  {renderFormComponent(data, `${name}[${index}].`, index)}
                  {index === formData.length - 1 && formData.length < limit && (
                    <SectionItemContainer>
                      <FloatingActionButton
                        text={addButtonText}
                        alert={alert}
                        kind="add"
                        onClick={() => {
                          push(createDefaultItemData());
                          onAddItem();
                        }}
                      />
                    </SectionItemContainer>
                  )}
                </React.Fragment>
              );
            })}
        </>
      )}
    </FieldArray>
  );
}
